import React from 'react';
import {connect} from 'react-redux';
import {dispatch} from 'redux';
import {Types} from 'api/resources';
import {pageCount} from "utils/DBUtils";

import PagingBar from 'components/common/PagingBar';
import {updatePageNumberForResourceAction} from "resources/actions";
import {createResourcePageSelector} from 'resources/selectors';

const getResourcePage = createResourcePageSelector(Types.Challenge);

const mapStateToProps = (state) => {
    const resourcePage = getResourcePage(state.resources);
    const { page, total, count, content } = resourcePage;
    return {
        currentPage: page,
        count: pageCount(total, count),
        maxPages: 10,
        total: total,
        numOfItemsOnPage: content.length
    }
};

const mapDispatchToProps = (dispatch) => ({
    onPageSelected: (page) => dispatch(updatePageNumberForResourceAction(Types.Challenge, page)),
    onNextClicked: (currentPage) => dispatch(updatePageNumberForResourceAction(Types.Challenge,currentPage+1)),
    onPreviousClicked: (currentPage) => dispatch(updatePageNumberForResourceAction(Types.Challenge,currentPage-1))
});

const BreakListPagingBar = connect(mapStateToProps, mapDispatchToProps)(PagingBar);

export default BreakListPagingBar;



// WEBPACK FOOTER //
// ./public/pages/ListBreaks/BreakListPagingBar.jsx